import "../styleSheets/recipientViewEdit.css";
import "../styleSheets/buttons.css";
import React, { useMemo } from "react";
import {useNavigate, useLocation, Navigate} from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { Recipient } from "../API";
import {capitalizeFirst, getSortedAssociatedMessages} from "../utilities/utilities";

type RecipientRow = Recipient;

function RecipientView() {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation("common");
    const recipient = (location.state as RecipientRow) || null;

    const onBack = () => navigate(-1);
    const onEdit = () => navigate(`/RecipientEdit/${recipient.id}`, { state: recipient });

    const associatedMessages = useMemo(
        () => getSortedAssociatedMessages(recipient),
        [recipient]
    );
    if (!recipient) {
        return <Navigate to="/Panel?selectedTab=recipients" replace />;
    }

    return (
        <div className="recipient-view-page">
            {/* Top nav */}
            <div className="recipient-topbar">
                <div className="recipient-topbar__nav">
                    {/* Row */}
                    <div className="recipient-topbar__container">
                        <button
                            type="button"
                            className="btn btn--gray btn--size-md btn--icon-left"
                            onClick={onBack}
                        >
                            <div className="btn__icon icon-chevron-left" aria-hidden="true" />
                            {t("common.back")}
                        </button>

                        {/* Center title (desktop/tablet) */}
                        <div className="recipient-topbar__title">
                            {capitalizeFirst(t("recipient.recipient"))}
                        </div>

                        <div className="recipient-topbar__actions">
                            <button
                                type="button"
                                className="btn btn--white btn--size-md"
                                onClick={onEdit}
                            >
                                {t("recipient.editRecipient")}
                            </button>
                        </div>
                    </div>

                    {/* Title below (mobile) */}
                    <div className="recipient-topbar__titleBelow">
                        {capitalizeFirst(t("recipient.recipient"))}
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="recipient-content">
                <div className="recipient-detailsCard">
                    <div className="recipient-detailsCard__title">
                        {t("recipient.title.recipientDetails")}
                    </div>

                    <div className="recipient-detailsCard__block">
                        <div className="recipient-detailsCard__label">{t("recipient.tableColumn.name")}</div>
                        <div className="recipient-detailsCard__value">
                            {recipient?.firstName} {recipient?.lastName}
                        </div>
                    </div>

                    <div className="recipient-detailsCard__block">
                        <div className="recipient-detailsCard__label">{t("recipient.email")}</div>
                        <div className="recipient-detailsCard__value">{recipient?.email}</div>
                    </div>

                    <div className="recipient-detailsCard__block">
                        <div className="recipient-detailsCard__label">{t("recipient.phone")}</div>
                        <div className="recipient-detailsCard__value">{recipient?.phone}</div>
                    </div>
                </div>

                <div className="recipient-detailsCard">
                    <div className="recipient-detailsCard__title">{t("common.associatedMessages")}</div>

                    <div className="recipient-associated">
                        {associatedMessages.length === 0 ? (
                            <div className="recipient-associated__item recipient-associated__item--empty">
                                {t("common.noAssociatedMessages")}
                            </div>
                        ) : (
                            associatedMessages.map((m: any) => (
                                <div key={m.message.id} className="recipient-associated__item">
                                    {m.message.title ?? t("message.untitledMessage")}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecipientView;
